import type { Table } from "@tanstack/react-table";
import type { IEquipo } from "../../../modelos/Equipo/entidades/IEquipo";
import type { ICatalogo } from "../../../globales/interfaces";
import type { IModeloEquipo } from "../../../modelos/Equipo/entidades/IModeloEquipo";
import type { IFiltroEquipo } from "../../../modelos/Equipo/entidades/IFiltroEquipo";

export interface ITablaEquiposVistaProps {
    tabla: Table<IEquipo>;
    equipoSeleccionado: IEquipo;
    manejarCambioValorEquipo: (campo: keyof IEquipo, valor: IEquipo[keyof IEquipo]) => void;
    agregarEditarEquipo: () => void;
    entidadesEquipo: IEntidadesEquipo;
    agregarError: (campo: keyof IEquipo, error: string) => Promise<void>;
    errores: Partial<Record<keyof IEquipo, string | null>>
      filtro: IFiltroEquipo;
    consultarEquipos: (filtros?: IFiltroEquipo) => void;
    manejarCambioFiltroEquipo: (campo: keyof IEquipo, valor: IEquipo[keyof IEquipo]) => void;
    // entidadesEquipo: IEntidadesEquipo;
    limpiarFiltros: () => void;
    habilitarFiltros: boolean;
    manejarHabilitarFiltros: (habilitar: boolean) => void;
    habilitarFormulario: boolean;
    manejarHabilitarFormulario: (habilitar: boolean) => void;
    descargarPlantilla: () => Promise<void>;
    cargaMasivaEquipos: () => void;
    pantallaCompleta?: boolean;
}

export const estadoInicialEquipo: IEquipo = {
    Id: 0,
    ProyectoId: 0,
    Codigo: '',
    Nombre: '',
    TipoEquipoId: 0,
    MarcaId: 0,
    ModeloId: 0,
    Adoptado: false,
    Pisos: 0,
    Paradas: 0,
    Entradas: 0,
    Capacidad: 0,
    Angulo: 0,
    Altura: 0,
    Ancho: 0,
    Velocidad: 0,
    EstadoEquipoId: 0,
    TaxonomiaJson: '',
    QrCode: '',
    InstaladoUtc: '',
    Activo: true,
    Eliminado: false,
    CreadoUtc: '',
    ActualizadoUtc: '',

    // DTOs opcionales
    TipoEquipo: undefined,
    Modelo: undefined,
    Marca: undefined,
    EstadoEquipo: undefined,
    Proyecto: undefined,
    Zona: undefined,
};


export interface IEntidadesEquipo {
    TiposEquipo: ICatalogo[];
    MarcasEquipo: ICatalogo[];
    ModelosEquipo: IModeloEquipo[];
    ModelosEquipoFiltrados: IModeloEquipo[];
    EstadosEquipo: ICatalogo[]
}

export interface IFormularioEquipoVistaProps {
    equipoSeleccionado: IEquipo;
    manejarCambioValorEquipo: (campo: keyof IEquipo, valor: IEquipo[keyof IEquipo]) => void;
    agregarEditarEquipo: () => void;
    entidadesEquipo: IEntidadesEquipo;
    agregarError: (campo: keyof IEquipo, error: string) => Promise<void>;
    errores: Partial<Record<keyof IEquipo, string | null>>
}

export interface IEquiposCVProps {
    idProyecto: number;
    pantallaCompleta?: boolean;
}

export interface IFiltroEquiposVistaProps {
    filtro: IFiltroEquipo;
    consultarEquipos: (filtros?: IFiltroEquipo) => void;
    manejarCambioFiltroEquipo: (campo: keyof IEquipo, valor: IEquipo[keyof IEquipo]) => void;
    entidadesEquipo: IEntidadesEquipo;
    limpiarFiltros: () => void;
}